<div class="container-fluid">
   <div class="row d-flex flex-column justify-content-center">
      <div class="col">
         <div class="col headerDiv ml-3">
            <h6 class="font-weight-bold">
               {{ 'public.order-confirmation.delivery-id' | translate }} : {{ orderConfirmation?.deliveryId }}
            </h6>
         </div>
         <div class="d-flex justify-content-xl-between justify-content-start parent">
            <div *ngIf="orderConfirmation" class="col-8 d-flex flex-column align-items-center parent-info">
               <div *ngIf="!isReturning" class="history d-flex justify-content-around mt-5 ml-5">
                  <div class="history-item">
                     <div
                        [ngClass]="{active: getStatusFromStatusesByStatusName('created')}"
                        class="history-item__circle"
                     >
                        <span
                           *ngIf="!getStatusFromStatusesByStatusName('created')"
                           [ngClass]="{'active-font': !getStatusFromStatusesByStatusName('created')}"
                           class="history-item__circle--text"
                           >1</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('created') &&
                              !getStatusFromStatusesByStatusName('processing')
                           "
                           [ngClass]="{'active-font': getStatusFromStatusesByStatusName('created')}"
                           class="history-item__circle--text"
                           >1</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('created') &&
                              getStatusFromStatusesByStatusName('processing')
                           "
                        >
                           <i class="bi bi-check"></i>
                        </span>
                     </div>
                     <p class="history-item__text">{{ 'Awaiting Payment' | translate }}</p>
                     <div class="history-item__date">
                        <span *ngIf="getStatusFromStatusesByStatusName('created')" class="step-subtitle">
                           {{ getDataTimeFromHistoryStatusesByHistoryName('AwaitingPayment') | dateTranslate: 'short' }}
                        </span>
                     </div>
                     <div class="middle-line"></div>
                  </div>

                  <div class="history-item">
                     <div
                        [ngClass]="{active: getStatusFromStatusesByStatusName('processing')}"
                        class="history-item__circle"
                     >
                        <span
                           *ngIf="!getStatusFromStatusesByStatusName('processing')"
                           class="history-item__circle--text"
                           >2</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('processing') &&
                              !getStatusFromStatusesByStatusName('shipped')
                           "
                           [ngClass]="{'active-font': true}"
                           class="history-item__circle--text"
                           >2</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('processing') &&
                              getStatusFromStatusesByStatusName('shipped')
                           "
                        >
                           <i class="bi bi-check"></i>
                        </span>
                     </div>
                     <p class="history-item__text">{{ 'Processing' | translate }}</p>
                     <div class="history-item__date">
                        <span *ngIf="getStatusFromStatusesByStatusName('processing')" class="step-subtitle">
                           {{ getDataTimeFromHistoryStatusesByHistoryName('Processing') | dateTranslate: 'short' }}
                        </span>
                     </div>
                  </div>

                  <div class="history-item">
                     <div
                        [ngClass]="{active: getStatusFromStatusesByStatusName('shipped')}"
                        class="history-item__circle"
                     >
                        <span *ngIf="!getStatusFromStatusesByStatusName('shipped')" class="history-item__circle--text"
                           >3</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('shipped') &&
                              !getStatusFromStatusesByStatusName('intransit')
                           "
                           [ngClass]="{'active-font': getStatusFromStatusesByStatusName('shipped')}"
                           class="history-item__circle--text"
                           >3</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('shipped') &&
                              getStatusFromStatusesByStatusName('intransit')
                           "
                        >
                           <i class="bi bi-check"></i>
                        </span>
                     </div>
                     <p class="history-item__text">{{ 'Ready' | translate }}</p>
                     <div class="history-item__date">
                        <span *ngIf="getStatusFromStatusesByStatusName('shipped')" class="step-subtitle">
                           {{ getDataTimeFromHistoryStatusesByHistoryName('Ready') | dateTranslate: 'short' }}
                        </span>
                     </div>
                  </div>

                  <div class="history-item">
                     <div
                        [ngClass]="{active: getStatusFromStatusesByStatusName('intransit')}"
                        class="history-item__circle"
                     >
                        <span *ngIf="!getStatusFromStatusesByStatusName('intransit')" class="history-item__circle--text"
                           >4</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('intransit') &&
                              !getStatusFromStatusesByStatusName('delivered')
                           "
                           [ngClass]="{'active-font': true}"
                           class="history-item__circle--text"
                           >4</span
                        >
                        <span
                           *ngIf="
                              getStatusFromStatusesByStatusName('intransit') &&
                              getStatusFromStatusesByStatusName('delivered')
                           "
                        >
                           <i class="bi bi-check"></i>
                        </span>
                     </div>
                     <p class="history-item__text">{{ 'Delivering' | translate }}</p>
                     <div class="history-item__date">
                        <span *ngIf="getStatusFromStatusesByStatusName('intransit')" class="step-subtitle">
                           {{ getDataTimeFromHistoryStatusesByHistoryName('Delivering') | dateTranslate: 'short' }}
                        </span>
                     </div>
                  </div>

                  <div class="history-item">
                     <div
                        [ngClass]="{active: getStatusFromStatusesByStatusName('delivered')}"
                        class="history-item__circle1"
                     >
                        <span *ngIf="!getStatusFromStatusesByStatusName('delivered')" class="history-item__circle--text"
                           >5</span
                        >
                        <span
                           *ngIf="getStatusFromStatusesByStatusName('delivered')"
                           [ngClass]="{'active-font': true}"
                           class="history-item__circle--text"
                           ><i class="bi bi-check"></i
                        ></span>
                     </div>
                     <p class="history-item__text">{{ 'Delivered' | translate }}</p>
                     <div class="history-item__date">
                        <span *ngIf="getStatusFromStatusesByStatusName('delivered')" class="step-subtitle">
                           {{ getDataTimeFromHistoryStatusesByHistoryName('Delivered') | dateTranslate: 'short' }}
                        </span>
                     </div>
                  </div>
               </div>

               <div *ngIf="isReturning" class="history d-flex mt-5 ml-5" style="padding-left: 5%">
                  <div class="history-item">
                     <div [ngClass]="{active: isReturning}" class="history-item__circle">
                        <span
                           *ngIf="isReturning"
                           [ngClass]="{'active-font': true}"
                           class="history-item__circle--text"
                        ></span>
                        <span *ngIf="isReturning">
                           <i class="bi bi-check"></i>
                        </span>
                     </div>
                     <p class="history-item__text">{{ status | translate }}</p>
                     <div class="history-item__date">
                        <span class="step-subtitle">
                           {{ historyStatus.date | dateTranslate: 'short' }}
                        </span>
                     </div>
                     <div class="alert-danger">
                        <span class="history-item__text">{{ orderConfirmation.statusReason }}</span>
                     </div>
                  </div>
               </div>
               <div class="col-10 details">
                  <div class="align-self-start col-6 d-flex">
                     <div class="d-flex">
                        <h5>{{ 'public.shipping-summary.delivery' | translate }}</h5>
                     </div>
                  </div>
                  <div
                     *ngIf="orderConfirmation?.carrier?.trackingUrl"
                     class="col-12"
                  >
                     <a
                        style="padding: 5px !important; text-decoration: auto; height: 64px !important"
                        class="
                           trackingOrder-button
                           btn btn-lg btn-outline-info
                           d-flex
                           align-items-center
                           justify-content-around
                           border border-primary
                        "
                        type="button"
                        href="{{ orderConfirmation?.carrier?.trackingUrl }}"
                        target=" _blank"
                     >
                        <img class="mr" src="{{ orderConfirmation.carrier.logo }}" width="60" height="60" />
                        <div style="text-decoration: none">
                           <p class="mb-0 h6 d-none d-md-block"> {{ 'public.shipping-summary.trackingUrl' | translate }} </p>
                           <p class="mb-0 d-block d-md-none small">{{ 'public.shipping-summary.trackingUrl' | translate }}</p>
                           <p class="small mb-0 d-none d-md-block" style="font-size: 12px">Pe pagina transportatorului </p>
                        </div>
                        <div class="divider-vertical d-none d-md-block"></div>
                        <div class="align-items-center d-none d-md-block text-rigth">
                           <p class="mb-0" style="font-size: 14px;">{{ 'public.shipping-summary.carrierWaybillNumber' | translate }}</p>
                           <p class="mb-0" style="font-size: 14px; font-weight: bold;">{{orderConfirmation.externalWaybillNumber}}</p>
                        </div>
                     </a>
                  </div>
                  <div class="col-6 col-sm-8 align-self-start d-flex d-md-none mt-4">
                     <div class="d-flex">
                        <span class="calendar"> <i class="bi bi-archive"></i> </span>
                        <p class="date-info">
                           {{ 'public.shipping-summary.carrierWaybillNumber' | translate }}
                           <span class="text-primary">{{orderConfirmation.externalWaybillNumber | uppercase}}</span>
                        </p>
                     </div>
                  </div>
                  <div class="col-6 col-sm-8 align-self-start d-flex mt-md-4 mt-0">
                     <div class="d-flex">
                        <span class="date"> <img src="./../../../../assets/images/order-details/truck.svg" /> </span>
                        <p class="muvi">{{ orderConfirmation?.carrier?.name | uppercase }}</p>
                     </div>
                  </div>

                  <div class="col-10 align-self-start d-flex mt-1">
                     <div class="d-flex">
                        <span class="calendar"><i class="bi bi-calendar-check"></i></span>
                        <p class="date-info">
                           {{ translatePath + 'arrives-between' | translate }}
                           {{ orderConfirmation?.estimatedDeliveryEnd | dateTranslate: 'fullDate' }}
                        </p>
                     </div>
                  </div>

                  <div class="align-self-start col-6 d-flex">
                     <div class="d-flex">
                        <h5>{{ 'public.shipping-summary.carrier-info' | translate }}</h5>
                     </div>
                  </div>
                  <div class="col-6 col-sm-8 align-self-start d-flex">
                     <div class="d-flex">
                        <span class="calendar"><i class="bi bi-telephone"></i></span>
                        <p class="muvi">{{ orderConfirmation?.carrier?.supportContacts.phoneNumber | uppercase }}</p>
                     </div>
                  </div>
                  <div class="col-6 col-sm-8 align-self-start d-flex">
                     <div class="d-flex">
                        <span class="calendar"><i class="bi bi-envelope"></i></span>
                        <p class="muvi">{{ orderConfirmation?.carrier?.supportContacts.email}}</p>
                     </div>
                  </div>
                  <div class="col-6 col-sm-8 align-self-start d-flex">
                     <div class="d-flex">
                        <span class="calendar"><i class="bi bi-phone"></i></span>
                        <p class="muvi">{{ orderConfirmation?.carrier?.supportContacts.mobilePhone | uppercase }}</p>
                     </div>
                  </div>
                  <div class="align-self-start col-6 d-flex">
                     <div class="d-flex">
                        <h5>{{ 'public.shipping-summary.payment' | translate }}</h5>
                     </div>
                  </div>

                  <div class="col-6 col-sm-8 align-self-start d-flex mt-4">
                     <div class="d-flex">
                        <span class="calendar"><i class="bi bi-hash"></i></span>
                        <p class="muvi">
                           {{ 'public.shipping-summary.invoice' | translate }} {{ orderConfirmation.invoiceId }}
                        </p>
                     </div>
                  </div>

                  <div class="col-6 col-sm-8 align-self-start d-flex">
                     <div class="d-flex">
                        <span class="calendar"><i class="bi bi-calendar"></i></span>
                        <p class="muvi">
                           {{ 'public.shipping-summary.place-order' | translate }}
                           {{ orderConfirmation?.orderDate | dateTranslate }}
                        </p>
                     </div>
                  </div>

                  <div *ngIf="user?.isAuthenticated">
                     <div
                        *ngIf="orderConfirmation?.deliveryAddress || orderConfirmation?.internationalDeliveryAddress"
                        class="align-self-start col-6 d-flex mb-4"
                     >
                        <div class="d-flex">
                           <h5>{{ translatePath + 'personal-info' | translate }}</h5>
                        </div>
                     </div>

                     <div
                        *ngIf="orderConfirmation?.deliveryAddress || orderConfirmation?.internationalDeliveryAddress"
                        class="d-flex col-12 pl-0 details-info"
                     >
                        <div class="col-6 user">
                           <span><i class="bi bi-person-square"></i></span>
                           <span *ngIf="orderConfirmation?.deliveryContactPerson?.firstName">
                              {{
                                 orderConfirmation?.deliveryContactPerson?.firstName +
                                    ' ' +
                                    orderConfirmation?.deliveryContactPerson?.lastName
                              }}
                           </span>
                           <div class="ml-5">
                              <p class="mb-0 ml-1">{{ orderConfirmation?.deliveryContactPerson?.email }}</p>
                              <p class="ml-1">{{ orderConfirmation?.deliveryContactPerson?.phone }}</p>
                           </div>
                        </div>
                        <div *ngIf="orderConfirmation?.internationalDeliveryAddress" class="col-8 pl-0 details-info">
                           <span><i class="bi bi-geo-alt"></i></span>
                           <span>
                              {{ orderConfirmation?.internationalDeliveryAddress?.street | titlecase }},
                              <span *ngIf="orderConfirmation?.internationalDeliveryAddress?.apartment">
                                 ap {{ orderConfirmation?.internationalDeliveryAddress?.apartment }},
                              </span>
                              {{ orderConfirmation?.internationalDeliveryAddress?.zipCode }}
                           </span>
                           <div class="ml-5">
                              <p class="mb-0 ml-1">
                                 {{ orderConfirmation?.internationalDeliveryAddress?.region }},
                                 {{ orderConfirmation?.internationalDeliveryAddress?.city }}
                              </p>
                              <p class="ml-1">{{ orderConfirmation?.internationalDeliveryAddress?.country }}</p>
                           </div>
                        </div>

                        <div *ngIf="orderConfirmation?.deliveryAddress" class="col-8 pl-0 details-info">
                           <span><i class="bi bi-geo-alt"></i></span>
                           <span>
                              {{ orderConfirmation?.deliveryAddress?.street?.value | titlecase }},
                              <span class="line-text">
                                 <span *ngIf="orderConfirmation?.deliveryAddress?.apartment">
                                    ap {{ orderConfirmation?.deliveryAddress?.apartment }} ,
                                 </span>
                                 MD-{{ orderConfirmation?.deliveryAddress?.zipCode }}
                              </span>
                           </span>
                           <div class="ml-5">
                              <p class="mb-0 ml-1">
                                 {{ orderConfirmation?.deliveryAddress?.region?.value }},
                                 {{ orderConfirmation?.deliveryAddress?.city?.value }}
                              </p>
                              <p class="ml-1">{{ orderConfirmation?.deliveryAddress?.country?.value | translate }}</p>
                           </div>
                        </div>
                     </div>
                  </div>
               </div>
            </div>
            <div *ngIf="orderConfirmation" class="summary col-xl-3 col-md-4">
               <app-shipping-summary
                  [option]="this.option"
                  [order]="orderDetails"
                  [providerData]="serviceProviderResponse"
               ></app-shipping-summary>
            </div>
            <div></div>
         </div>
      </div>
   </div>
</div>
